import { Flex, Text, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { componentState } from "../../../atoms/componentState";
import {
  BLUECARD,
  BLUEMONEDD,
  BLUEMONEDDBUTTONS,
  VARIANT,
} from "../../../constants/colors";
import { useSetRecoilState } from "recoil";
import {
  CEPFormater,
  CNPJFormater,
  CPFFormater,
  PhoneFormater,
} from "../../../defaultFunctions/formaters";
import ClientApi from "../../../services/clientApi";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../routes/privateRoute";
import { ClientInterface } from "../../../interfaces/defaultInterfaces";
import moment from "moment";
import { FaPlay } from "react-icons/fa";
import CardPIXBoleto from "./components/cardPIXBoleto";
import CardTableTarifas from "./components/cardTableTarifas";
import PlanoApi from "../../../services/PlanosApi";
import { useRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

export interface PlanosInterface {
  idBandeira: number;
  idForma: string;
  idPlano: number;
  idProduto: number;
  percentual: number;
  valor: number;
}

export default function TarifasCliente() {
  const setHeaderLocation = useSetRecoilState(componentState);

  // const [cliente, setCliente] = useState<ClientInterface>();
  const [planos, setPlanos] = useState(Array<PlanosInterface>);

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const id = Number(jwtToken.idCliente);

  const VENDAID = 1;
  const VENDADIGITADAID = 2;
  const VENDARECORRENTEID = 3;

  useEffect(() => {
    setHeaderLocation("Dados Pessoais");
    if (id !== 0) {
      // getClientByID();
      getPlanosDoCliente(id);
    }
  }, [id]);

  // async function getClientByID() {
  //   try {
  //     const response = await ClientApi.getClientPerId(id);

  //     // getPlanosDoCliente(response.idPlano);
  //     getPlanosDoCliente(id);
  //     // setCliente(response);
  //   } catch (error) {
  //     console.log("error :", error);
  //   }
  // }

  const [loading, setLoading] = useState(false);

  async function getPlanosDoCliente(id: number) {
    try {
      setLoading(true);
      const response = await PlanoApi.getRegisteredPlanoPerId(id);
      // console.log("response dos planos do cliente ", response);
      setPlanos(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error :", error);
    }
  }

  const valorPIXDIRETO = planos.length
    ? planos.filter(
        (item) =>
          item.idProduto === 4 &&
          item.idForma.trim() === "P" &&
          item.idBandeira === 14
      )[0]?.percentual || 0
    : 0;

  const valorPIX = planos.length
    ? planos.filter(
        (item) => item.idProduto === 1 && item.idForma.trim() === "P"
      )[0].percentual
    : 0;
  const valorBoleto = planos.length
    ? planos.filter(
        (item) => item.idProduto === 1 && item.idForma.trim() === "B"
      )[0].valor
    : 0;
  const valorBOLEPIX = planos.length
    ? planos.filter(
        (item) => item.idProduto === 1 && item.idForma.trim() === "BP"
      )[0]?.valor ?? 0
    : 0;
  const percentBOLEPIX = planos.length
    ? planos.filter(
        (item) => item.idProduto === 1 && item.idForma.trim() === "BP"
      )[0]?.percentual ?? 0
    : 0;
  return (
    <Flex
      w={"99.5%"}
      h={"99.5%"}
      flexDirection={"column"}
      bgColor={"#F5F5F5"}
      //   justifyContent={"center"}
      alignItems={"center"}
      overflowY="scroll"
    >
      <Flex
        w={"98%"}
        h={"10%"}
        alignItems={"center"}
        mx={2}
        // borderBottom={`2px solid ${BLUEMONEDD}`}
      >
        <FaPlay color={BLUEMONEDDBUTTONS} size="2rem" />
        <Text
          color={BLUEMONEDDBUTTONS} // colors.BLUEMONEDD cor original
          fontSize={"2rem"}
          fontWeight={"bold"}
          ml={2}
        >
          MEU PLANO DE TAXAS
        </Text>
      </Flex>

      {loading ? (
        <Flex
          w={"90%"}
          h={"85%"}
          alignItems={"center"}
          mx={6}
          justifyContent={"center"}
          // my={2}
          bgColor={"#F7F7F7"}
        >
          <Spinner size={"lg"} color={VARIANT} />
        </Flex>
      ) : (
        <Flex
          w={"90%"}
          h={"85%"}
          alignItems={"center"}
          mx={6}
          // my={2}
          bgColor={"#F7F7F7"}
        >
          <Flex
            w={"100%"}
            h={"100%"}
            // bgColor={"blue"}
            flexDirection={"column"}
            py={4}
          >
            <Flex
              w={"100%"}
              h={"fit-content"}
              // bgColor={"green"}
              my={1}
              alignItems={"center"}
            >
              <CardPIXBoleto text={"PIX"} value={`${valorPIX} %`} />
              <CardPIXBoleto text={"Boleto"} value={`${valorBoleto} %`} />
              <CardPIXBoleto text={"Custo Boleto Emitido"} value={`R$ 1,90`} />
              {/* {valorPIXDIRETO > 0 && (
                <CardPIXBoleto
                  text={"PIX DIRETO"}
                  value={`${valorPIXDIRETO.toFixed(2)} %`}
                />
              )} */}
              <CardPIXBoleto
                text={"BOLEPIX EM PERCENTUAL"}
                value={`${percentBOLEPIX} % + ${valorBOLEPIX} R$`}
              />
            </Flex>
            {planos.filter((item) => item.idProduto === VENDAID).length ? (
              <Flex
                w={"100%"}
                h={"fit-content"}
                // bgColor={"green"}
                my={1}
                alignItems={"center"}
              >
                <CardTableTarifas
                  title={"venda na maquina"}
                  data={planos.filter((item) => item.idProduto === VENDAID)}
                />
              </Flex>
            ) : (
              <></>
            )}
            {planos.filter((item) => item.idProduto === VENDADIGITADAID)
              .length ? (
              <Flex
                w={"100%"}
                h={"fit-content"}
                // bgColor={"green"}
                my={1}
                alignItems={"center"}
              >
                <CardTableTarifas
                  title={"venda digitada"}
                  data={planos.filter(
                    (item) => item.idProduto === VENDADIGITADAID
                  )}
                />
              </Flex>
            ) : (
              <></>
            )}
            {planos.filter((item) => item.idProduto === VENDADIGITADAID)
              .length ? (
              <Flex
                w={"100%"}
                h={"fit-content"}
                // bgColor={"green"}
                my={1}
                alignItems={"center"}
              >
                <CardTableTarifas
                  title={"venda recorrente"}
                  data={planos.filter(
                    (item) => item.idProduto === VENDARECORRENTEID
                  )}
                />
              </Flex>
            ) : (
              <></>
            )}
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}
